import "./SetupHeading.scss";
import { setupCreateNewEngHeader } from "../../util/constants";

export function SetupHeading() {
  return <span className="setup-heading">{setupCreateNewEngHeader}</span>;
}
